import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import cartStore from 'src/stores/cart-store';

import { IS_MESHULAM_PAYMENT, LOCALES } from 'src/constants';
import { formatMoney } from 'src/utils';

import './payment-info.scss';

const PaymentInfo = observer(() => {
  const formattedTotal = formatMoney(cartStore.totalSum);

  return (
    <div className="payment-info">
      <div className="payment-info__wrapper">
        <dl
          className={classNames(
            'payment-info__list',
            IS_MESHULAM_PAYMENT && 'payment-info__list_he'
          )}
        >
          <dt className="payment-info__key">{LOCALES.PURCHASER}:</dt>
          <dd className="payment-info__value">{cartStore.clientName}</dd>
          <dt className="payment-info__key">{LOCALES.ORDER_TOTAL}:</dt>
          <dd className="payment-info__value">{formattedTotal}</dd>
        </dl>
      </div>
    </div>
  );
});

export default PaymentInfo;
